import PropTypes from 'prop-types';

const MessageIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.19999 4.79999C6.56347 4.79999 5.95302 5.05285 5.50294 5.50294C5.05285 5.95302 4.79999 6.56347 4.79999 7.19999V39.8058L10.3029 34.3029C10.753 33.8528 11.3635 33.6 12 33.6H40.7999C41.4365 33.6 42.0469 33.3471 42.497 32.897C42.9471 32.4469 43.1999 31.8365 43.1999 31.2V7.19999C43.1999 6.56347 42.9471 5.95302 42.497 5.50294C42.0469 5.05285 41.4365 4.79999 40.7999 4.79999H7.19999ZM2.10883 2.10883C3.45909 0.758568 5.29043 0 7.19999 0H40.7999C42.7095 0 44.5408 0.758568 45.8911 2.10883C47.2414 3.45909 47.9999 5.29043 47.9999 7.19999V31.2C47.9999 33.1095 47.2414 34.9409 45.8911 36.2911C44.5408 37.6414 42.7095 38.3999 40.7999 38.3999H12.9941L4.09705 47.297C3.41066 47.9834 2.37837 48.1887 1.48156 47.8172C0.58474 47.4458 0 46.5706 0 45.5999V7.19999C0 5.29043 0.758568 3.45909 2.10883 2.10883Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.9999 14.4C35.9999 15.7255 34.9254 16.8 33.6 16.8H14.4C13.0745 16.8 12 15.7255 12 14.4C12 13.0745 13.0745 12 14.4 12H33.6C34.9254 12 35.9999 13.0745 35.9999 14.4Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.6 24C33.6 25.3254 32.5254 26.4 31.2 26.4H14.4C13.0745 26.4 12 25.3254 12 24C12 22.6745 13.0745 21.6 14.4 21.6H31.2C32.5254 21.6 33.6 22.6745 33.6 24Z"
        fill={fill}
      />
    </svg>
  </div>
);

MessageIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

MessageIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default MessageIcon;
